import { Handshake } from "lucide-react";

const TIER_COLOR = (type = "") => {
  const t = type.toLowerCase();
  if (t.includes("title") || t.includes("presenting")) return "text-amber-300 border-amber-400/50";
  if (t.includes("gold")) return "text-yellow-300 border-yellow-400/40";
  if (t.includes("silver")) return "text-zinc-200 border-zinc-400/50";
  if (t.includes("bronze")) return "text-orange-300 border-orange-400/40";
  return "text-pb-cyan border-pb-cyan/40";
};

export default function SponsorStrip({ sponsors, tid, compact = true }) {
  if (!sponsors?.length) return null;
  return (
    <div className="border-t border-pb-border/60 pt-2 mt-1" data-testid={`sponsors-${tid}`}>
      <div className="flex items-center gap-1.5 text-[9px] uppercase tracking-[0.25em] text-zinc-500 mb-1.5"><Handshake className="w-3 h-3" /> Event Sponsors</div>
      <div className="flex flex-wrap gap-1.5">
        {sponsors.map((sp, i) => {
          const inner = (
            <>
              {sp.logo ? <img src={sp.logo} alt={sp.name} className="h-5 w-5 object-contain bg-black" loading="lazy" />
                : <span className="h-5 w-5 grid place-items-center bg-pb-elevated text-[9px] font-black text-zinc-300">{sp.name[0]}</span>}
              <span className="leading-none">
                <span className="block text-[11px] text-white font-semibold">{sp.name}</span>
                <span className={`block text-[8px] uppercase tracking-widest ${TIER_COLOR(sp.type).split(" ")[0]}`}>{sp.type}</span>
              </span>
            </>
          );
          const cls = `flex items-center gap-1.5 border bg-pb-elevated/60 px-1.5 py-1 ${TIER_COLOR(sp.type).split(" ")[1]} ${sp.url ? "hover:bg-pb-elevated transition-colors" : ""}`;
          return sp.url ? (
            <a key={i} href={sp.url} target="_blank" rel="noopener noreferrer sponsored" className={cls} data-testid={`sponsor-${tid}-${i}`} onClick={(e) => e.stopPropagation()}>{inner}</a>
          ) : (
            <div key={i} className={cls} data-testid={`sponsor-${tid}-${i}`}>{inner}</div>
          );
        })}
      </div>
    </div>
  );
}
